import {AIMarkingColor} from "../types/AIMarkingColor";
import {AIMarkingType} from "../types/AIMarkingType";

const AI_MARKING_ASSETS: Record<AIMarkingType, Record<AIMarkingColor, {solid: string; transparent: string}>> = {
    ai: {
        black: {
            solid: require("../assets/ai-black.svg"),
            transparent: require("../assets/ai-black-transparent.svg")
        },
        white: {
            solid: require("../assets/ai-white.svg"),
            transparent: require("../assets/ai-white-transparent.svg")
        }
    },
    "ai-generated": {
        black: {
            solid: require("../assets/ai-generated-black.svg"),
            transparent: require("../assets/ai-generated-black-transparent.svg")
        },
        white: {
            solid: require("../assets/ai-generated-white.svg"),
            transparent: require("../assets/ai-generated-white-transparent.svg")
        }
    },
    "ai-modified": {
        black: {
            solid: require("../assets/ai-modified-black.svg"),
            transparent: require("../assets/ai-modified-black-transparent.svg")
        },
        white: {
            solid: require("../assets/ai-modified-white.svg"),
            transparent: require("../assets/ai-modified-white-transparent.svg")
        }
    }
};

export const getAIMarkingAsset = (type: AIMarkingType, color: AIMarkingColor, transparent: boolean): string => {
    return transparent ? AI_MARKING_ASSETS[type][color].transparent : AI_MARKING_ASSETS[type][color].solid;
};
import {AIMarkingColor} from "../types/AIMarkingColor";
import {AIMarkingType} from "../types/AIMarkingType";

const AI_MARKING_ASSETS: Record<AIMarkingType, Record<AIMarkingColor, {solid: string; transparent: string}>> = {
    ai: {
        black: {
            solid: require("../assets/ai-black.svg"),
            transparent: require("../assets/ai-black-transparent.svg")
        },
        white: {
            solid: require("../assets/ai-white.svg"),
            transparent: require("../assets/ai-white-transparent.svg")
        }
    },
    "ai-generated": {
        black: {
            solid: require("../assets/ai-generated-black.svg"),
            transparent: require("../assets/ai-generated-black-transparent.svg")
        },
        white: {
            solid: require("../assets/ai-generated-white.svg"),
            transparent: require("../assets/ai-generated-white-transparent.svg")
        }
    },
    "ai-modified": {
        black: {
            solid: require("../assets/ai-modified-black.svg"),
            transparent: require("../assets/ai-modified-black-transparent.svg")
        },
        white: {
            solid: require("../assets/ai-modified-white.svg"),
            transparent: require("../assets/ai-modified-white-transparent.svg")
        }
    }
};

export const getAIMarkingAsset = (type: AIMarkingType, color: AIMarkingColor, transparent: boolean): string => {
    return transparent ? AI_MARKING_ASSETS[type][color].transparent : AI_MARKING_ASSETS[type][color].solid;
};
